import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { CookieHelperService } from '../../../shared/services/cookie-helper.service';

@Injectable()
export class CustomerAccountGuard implements CanActivate {

    constructor(
        private cookieService: CookieHelperService,
    ) { }

    canActivate() {
        const leadId = this.cookieService._getCookie('leadId');
        if (!leadId) {
            (<any>window).location.href = '/customer-portal-login/';
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/customer-account/services/customer-account.guard.ts